import React from 'react';
import loadable from '@loadable/component';

const UsefulInfo = loadable(() => import('../components/UsefulInfo/UsefulInfo'));

const InfoPage = () => <UsefulInfo/>;


export default InfoPage